import { DataGrid } from '@tableau/widgets-datagrid';

import { ItemsCellWithPopover } from '~src/spacesPlatform/components/ListView/dataGridCells/ItemsCellWithPopover';
import { SortableHeader } from '~src/spacesPlatform/components/ListView/SortableHeader';
import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

import { Messages } from '../../../codegen/Localize';
import { FlowConnectionsSubplaceMetadata } from '../FlowConnectionsSubplace';
import { makeGetStepNamesForRow } from './FlowCellHelpers';

export function FlowConnectionOutputStepsColumn(params: {
  readonly spaceInfo: SpaceInfo;
  readonly currentSort: ReadonlyArray<IOrderClause>;
  readonly changeSort: (field: string) => void;
}): DataGrid.Column {
  const sortableHeaderFormatter = SortableHeader.Formatter(params.currentSort, params.changeSort);
  const flow = params.spaceInfo.item as unknown as FlowConnectionsSubplaceMetadata;
  const outputSteps = flow.subplaceMetadata?.outputSteps ?? [];
  return {
    name: 'output-steps-col',
    dataKey: 'flowOutputSteps',
    headerText: Messages.outputSteps(),
    sortable: false,
    headerFormatter: sortableHeaderFormatter,
    cellFormatter: StyledCellFormatter(ItemsCellWithPopover(
      makeGetStepNamesForRow(outputSteps),
      Messages.outputStepsCount
    ))
  };
}
